import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';
import { HomeComponent } from './pages/home/home.component';
import { DevExtremeModule } from 'devextreme-angular';
import { RegistrationComponent } from './pages/registration/registration.component';
import { EditProviderComponent } from './pages/edit-provider/edit-provider.component';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { CredentialsService } from './services/Settings/credentials.service';
import { SettingsComponent } from './pages/settings/settings.component';
import config from 'devextreme/core/config';
import 'devextreme-intl';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegistrationService } from './services/registration.service';
import { DxDataGridModule } from "devextreme-angular";
import { CodeSetupComponent } from './pages/code-setup/code-setup.component';
import { PasswordFormComponent } from './shared/components/password-form/password-form.component';
import { FinancialSettingsComponent } from './pages/financial-settings/financial-settings.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { ChangePasswordComponent } from './shared/components/change-password/change-password.component';
import { ProviderManagementComponent } from './pages/provider-management/provider-management.component';
import { ForgotPasswordComponent } from './shared/components/forgot-password/forgot-password.component';
import { PortalDownloadComponent } from './pages/portal-download/portal-download.component';
import { UserManagementDOHComponent } from './pages/user-management-doh/user-management-doh.component';
import { UserManagementAdminComponent } from './pages/user-management-admin/user-management-admin.component';
import { UserProfileUpdateComponent } from './pages/user-profile-update/user-profile-update.component';
import { ProviderInformationComponent } from './pages/provider-information/provider-information.component';
import { SecurityQuestionsComponent } from './shared/components/sec-questions/sec-questions.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { MatOptionModule, MatSelectModule } from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

// import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';

const routes: Routes = [
  {
    path: 'pages/settings/settings',
    component: SettingsComponent,
  },
  {
    path: 'pages/settings/financial',
    component: FinancialSettingsComponent,
  },
  {
    path: 'pages/users',
    component: UserManagementComponent,
  },
  {
    path: 'pages/dohusers',
    component: UserManagementDOHComponent,
  },
  {
    path: 'pages/adminusers',
    component: UserManagementAdminComponent
  },
  {
    path: 'pages/profile',
    component: UserProfileUpdateComponent,
  },
  {
    path: 'pages/registration',
    component: RegistrationComponent,
  },
  {
    path: 'pages/edit',
    component: EditProviderComponent,
  },
  {
    path: 'pages/manage',
    component: ProviderManagementComponent,
  },
  {
    path: 'pages/info',
    component: ProviderInformationComponent,
  },
  {
    path: 'pages/codesetup',
    component: CodeSetupComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
  },
  {
    path: 'password-form',
    component: PasswordFormComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'sec-questions',
    component: SecurityQuestionsComponent,
  },
  {
    path: 'portal-download',
    component: PortalDownloadComponent,
  },
  {
    path: '**',
    redirectTo: 'login-form',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }), 
    DevExtremeModule,
    DxDataGridModule,
    HttpClientModule, 
    CommonModule, 
    FormsModule, 
    RecaptchaModule,  
    MatSelectModule, 
    CdkTableModule, 
    MatOptionModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
  
  ],
  providers: [AuthGuardService, CredentialsService, RegistrationService],
  exports: [RouterModule],
  declarations: [HomeComponent, RegistrationComponent, CodeSetupComponent, SettingsComponent, PortalDownloadComponent,
    EditProviderComponent, ProviderManagementComponent, ProviderInformationComponent, LoginFormComponent, PasswordFormComponent, ChangePasswordComponent,
    ForgotPasswordComponent, SecurityQuestionsComponent, FinancialSettingsComponent, UserManagementComponent, UserManagementDOHComponent, UserManagementAdminComponent, UserProfileUpdateComponent],
})

export class AppRoutingModule {
  constructor() {
    config({ defaultCurrency: 'AED' });
    config({ editorStylingMode: 'underlined' });
  }
}